<template>
  <div>
    <nav class="navbar has-shadow is-fixed" v-bind:class="{ 'is-dark': isDark }">
      <div class="navbar-brand">
        <router-link to="/" class="navbar-item" ><strong>The Score</strong></router-link>
        <div class="navbar-burger" @click="toggleMobileNav" >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div class="navbar-menu"
           v-bind:class="{ 'is-active': mobileNavVisible }" >

        <div class="navbar-start" v-if="chapter" >
          <router-link :to="'/chapter/' + chapter.id"
                       class="navbar-item" >{{ currentTitle }}</router-link>
        </div>
        <div class="navbar-start" v-else >
          <router-link to="/" class="navbar-item" >{{ currentTitle }}</router-link>
        </div>

        <div class="navbar-end">
          <a class="navbar-item" >
            <span class="icon"><i class="ion ion-ios-search"></i></span>
          </a>
          <a class="navbar-item"
             @click="toggleModal" >
            <span class="icon"><i class="ion ion-ios-more"></i></span>
          </a>
        </div>
      </div>
    </nav>
    <citation :isActive="modalVisible" v-on:close-citation="toggleModal" ></citation>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Citation from '@/components/Citation.vue'
export default {
  name: 'navbar',
  components: { Citation },
  computed: {
    ...mapGetters(['chapter']),
    currentTitle () {
      if (this.chapter) {
        return `${this.chapter.title} | ${this.chapter.artist}`
      } else {
        return 'Contents'
      }
    },
    isDark () {
      if (this.currentTitle === 'Contents') {
        return true
      } else {
        return false
      }
    }
  },
  data () {
    return {
      modalVisible: false,
      mobileNavVisible: false
    }
  },
  methods: {
    toggleModal () {
      this.modalVisible = !this.modalVisible
    },
    toggleMobileNav () {
      this.mobileNavVisible = !this.mobileNavVisible
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NavBar.vue?60598718